import { render } from "./SenderMsg.vue?vue&type=template&id=47bc8b33&scoped=true"
import script from "./SenderMsg.vue?vue&type=script&lang=js"
export * from "./SenderMsg.vue?vue&type=script&lang=js"

import "./SenderMsg.vue?vue&type=style&index=0&id=47bc8b33&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bc8b33"]])

export default __exports__